
/* eslint-disable no-throw-literal */
import {
  GET_NORMAL_QUESTION_ALL,
  GET_NORMAL_QUESTION_LIST,
  NORMAL_QUESTION_DELETE,
  NORMAL_QUESTION_CREATE,
  GET_NORMAL_QUESTION_DETAIL,
  NORMAL_QUESTION_UPDATE
} from './mutation-types'

export default {
  state: {},
  getters: {},
  actions: {
    async [GET_NORMAL_QUESTION_ALL] ({ dispatch }, params) {
      const res = await dispatch('apiGet', { url: '/master/evaluate/questions/all_get', data: params.data })
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        }
      }
      return res.data
    },
    [GET_NORMAL_QUESTION_LIST] ({ dispatch }, params) {
      return new Promise((resolve, reject) => {
        dispatch('apiGet', { url: '/master/evaluate/questions', data: params.data })
        .then(res => {
          if (res.status === 200 || res.status === 204) {
            if (res.data.error) {
              reject(res.data.error)
            } else {
              resolve(res.data)
            }
          }
        })
        .catch(err => {
          reject(err)
        })
      })
    },
    [NORMAL_QUESTION_DELETE] ({ dispatch }, params) {
      return new Promise((resolve, reject) => {
        dispatch('apiDelete', {url: `/master/evaluate/questions/${params.data.id}`})
        .then(res => {
          if (res.status === 200 || res.status === 204) {
            if (res.data.error) {
              reject(res.data.error)
            } else {
              resolve(res.data)
            }
          }
        })
        .catch(err => {
          reject(err)
        })
      })
    },
    [NORMAL_QUESTION_CREATE] ({dispatch}, params) {
      return new Promise((resolve, reject) => {
        dispatch('apiPost', { url: '/master/evaluate/questions', data: params.data })
        .then(res => {
          if (res.status === 200 || res.status === 204) {
            if (res.data.error) {
              reject(res.data.error)
            } else {
              resolve(res.data)
            }
          }
        })
        .catch(err => {
          reject(err)
        })
      })
    },
    [GET_NORMAL_QUESTION_DETAIL] ({ dispatch }, params) {
      return new Promise((resolve, reject) => {
        dispatch('apiGet', { url: `/master/evaluate/questions/${params.id}/edit` })
        .then(res => {
          if (res.status === 200 || res.status === 204) {
            if (res.data.error) {
              reject(res.data.error)
            } else {
              resolve(res.data)
            }
          }
        })
        .catch(err => {
          reject(err)
        })
      })
    },
    [NORMAL_QUESTION_UPDATE] ({ dispatch }, params) {
      return new Promise((resolve, reject) => {
        dispatch('apiPatch', { url: `/master/evaluate/questions/${params.id}`, data: params.data })
        .then(res => {
          if (res.status === 200 || res.status === 204) {
            if (res.data.error) {
              reject(res.data.error)
            } else {
              resolve(res.data)
            }
          }
        })
        .catch(err => {
          reject(err)
        })
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/normal-question.js